import { api } from "@/lib/site";

const VID_KEY = "ccc_visitor_id";

export function getVisitorId() {
  let id = localStorage.getItem(VID_KEY);
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(VID_KEY, id);
  }
  return id;
}

export function trackSection(section) {
  api
    .post("/analytics/track", {
      visitor_id: getVisitorId(),
      path: "/",
      type: "section",
      section,
    })
    .catch(() => {});
}
